<template>
  <div class="hotels">
    <div class="flex-container">
      <!-- <p>Koncern fra component: {{ this.$route.params.koncern }}</p> -->
      <div v-for="hotel in this.$store.getters.hotels" v-bind:key="hotel.postnr" class="flex-item">
        <router-link :to="{name: '2-VaerelseEllerParkering', params: {postnr: hotel.postnr} }" class="hotelButton">{{hotel.beskrivelse}}</router-link>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'hotelChooser',
      props: ['koncern'],
      
    }
  },
  mounted() {
    this.getHotels();

  },
  methods: {
    getHotels: function() {
      this.$store.dispatch('getHotelData', {koncern: this.$route.params.koncern});
    }
  }

}
</script>


<style scoped>

.flex-container {
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction:row;
  -ms-flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 55vw;
}

.flex-item {
  padding: 10px;
  width: 85vw;
  max-width: 330px;
  height: 150px;
  margin-top: 10px;
  display: flex;
}

/* Denne rammer specifikt iOS devices */
/* @supports (-webkit-touch-callout: none) {
  .flex-container {
    margin-right: 10px;
    margin-left: 20px;
    padding-left: 0px;
    padding-right: 0px;
  }
} */

</style>
